import {comMapping} from "../../../../../../util/Function/comMapping";

export function getdata() {
    let obj = {
        searchlist: [
            {
                prop: "shangpmc",
                label: '商品名称',
                type: "input",
            },
            {
                prop: "jzjtbs",
                label: '即征即退标识',
                type: "select",
                selectval: comMapping.$flag
            },
            {
                prop: "shuisflbm",
                label: '税收分类编码',
                type: "input",
            },
            {
                prop: "shuil",
                label: '税率',
                type: "select",
            },
            {
                prop: "shuie",
                label: '税额',
                type: "input",
            },
        ],
        searchdata: {
            shangpmc: "",
            jzjtbs: "",
            shuisflbm: "",
            shuil: "",
            shuie: "",
        },
        headData: [
            {
                title: "发票明细行",
                prop: "mingxbh",
                width: 80,
                custom: true
            },
            {
                title: "商品名称",
                prop: "shangpmc",
                width: 80,
                custom: true
            },
            {
                title: "税收分类编码",
                prop: "shuisflbm",
                custom: true,
                width: 80,
            },
            {
                title: "税率",
                prop: "shuil",
                width: 120,
                custom: true
            },
            {
                title: "未税金额",
                prop: "buhsje",
                width: 90,
                AmountFormat: true,
                custom: true
            },
            {
                title: "税额",
                prop: "shuie",
                width: 110,
                AmountFormat: true,
                custom: true
            },
            {
                title: "退税税额",
                prop: "tuisshuie",
                width: 80,
                AmountFormat: true,
                custom: true
            },
            {
                title: "即征即退标识",
                prop: "jzjtbs",
                width: 90,
                custom: true
            },
        ],
    }
    return obj
}
